import React, { useEffect, useState } from 'react';
import FeatherIcon from 'feather-icons-react';
import Avatar from "../../images/avatar.png";
import { useHistory, useParams } from "react-router-dom";
import { toggleLoader } from "../../shared/actions/setting";
import { useDispatch } from "react-redux";
import axios from "axios";
import { getUserId, isSuper } from "../../shared/authentication/authentication";
import { toast } from "react-toastify";
import Dropdown from "react-bootstrap/Dropdown";
import { isEmpty, storeInLocalStorage, toCapsFirst } from "../../shared/util/utils";
import { getSelectedMachine } from "../../actions/machine";

const MachineItem = (props) => {
  const { departmentID } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();
  const [latestJob, setLatestJob] = useState({});
  const [dropDown, setDropDown] = useState(false);
  const jobEmployees = (latestJob.employees || []).filter(item => item && item.employee);

  useEffect(() => {
    dispatch(toggleLoader(true));
    axios.get(process.env.REACT_APP_HOST + 'user/'
      + getUserId() + '/machine/' + props.machine.id + '/job/active')
      .then(res => {
        setLatestJob(res.data.content);
      }).catch(error => {
        if (error.response.status === 422) {
          console.error(error.response.data.message);
        }
      }
      ).finally(() => {
        dispatch(toggleLoader(false))
      })

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.machine.id]);

  const goToReport = () => {
    dispatch(getSelectedMachine(props.machine));
    storeInLocalStorage("machineId", props.machine.id);
    storeInLocalStorage("secondNav", props.machine.name);
    history.push('/' + departmentID + '/' + props.machine.id + "/report");

  };

  function clickArrowDown() {
    setDropDown(true);
  }

  function clickArrowUp() {
    setDropDown(false);
  }

  function convertTime(time) {
    if(time.includes('day')){
      return time;
    }else{
      const [hours, mins] = time.split(':');
		if (hours === '00') {
			return `${mins}min`;
		} else {
			return `${hours}h ${mins}min`;
		}
    }
	}

  return (
    <div>
      <div className="single-card-machineList">
        <div className="single-card-header-departmentList ">
          <div className="row">
            <div className="col-5 margin-auto">
              <div className="card-header-text-departmentList">
                <span className="heading-machine limit-department-header-name">{props.machine.name.toUpperCase()}</span>
              </div>
            </div>
            <div className="col-6 margin-auto text-right">
              {latestJob.active ?
                <div>
                  <FeatherIcon className="icon-green" icon="circle" />
                </div> :
                <div>
                  <FeatherIcon className="icon-red" icon="circle" />
                </div>
              }
            </div>
            {
              isSuper() && <div className="col-1 margin-auto">
                <Dropdown>
                  <Dropdown.Toggle id="dropdown-custom-components-factoryspy">
                    <FeatherIcon
                      className={dropDown ? "vertical-icon-b vertical-icon-bb text-white" : "vertical-icon-b text-white"}
                      icon="more-vertical" />

                    {dropDown ? <div onClick={clickArrowUp.bind(this)} className="bell-icon text-black"></div> :
                      <div onClick={clickArrowDown.bind(this)} className="bell-icon"></div>
                    }
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => {
                      props.parentCallbackEdit(props.machine.id, props.index, props.machine.name, props.machine.circumference, props.machine.type, props.machine.kitId);
                    }}>
                      <FeatherIcon
                        className="spy-actions-icon" icon="edit" /><label className="spy-actions">Edit</label>
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => props.parentCallback(props.machine.id)} >
                      <FeatherIcon
                        className="spy-actions-icon" icon="trash-2" /><label className="spy-actions">Delete</label>
                    </Dropdown.Item>
                    <Dropdown.Item>
                      <FeatherIcon
                        className="spy-actions-icon" icon="settings" /><label className="spy-actions">Setting</label>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            }
          </div>
        </div>
        {!isEmpty(latestJob) ?
          <div className="single-card-content">
            <div className="row">
              <div className="col-12 sa-cursor"  onClick={goToReport}>
                <div className="single-card-machineListHeader">
                    <div className="heading-jobId">
                      <label>{latestJob.jId === "" || latestJob.jId == null ? `Job No : Job ID`: `Job No : #${latestJob.jId}`}</label>
                    </div>
                    <div className="heading-job">
                      <label>{latestJob.designName === "" || latestJob.designName == null ? `Design Name`: latestJob.designName}</label>
                    </div>
                    <div className="heading-customerName">
                      <label>{latestJob.customer === "" || latestJob.customer == null ? `Customer Name`: latestJob.customer.name}</label>
                    </div>
                </div>
                <div className='p-2'>
                  <div className="row p-1">
                    <div className="col-6">
                      <div className="sensor-details-machine" title="Duration">
                        <div className="sensor-icon-machine status-blue">
                          <FeatherIcon className={""} icon="clock" />
                        </div>
                        <div className="sensor-data-varna">
                          {/* TODO: Remove the mb-1 styling on next phase when enabling the below value */}
                          <div className="sensor-value limit-sensorValue-varna mb-1">
                            <label className='mb-0'>{latestJob.time === "" || latestJob.time == null ? `00:00:00 h`: `${convertTime(latestJob.time.slice(0 , -1))}`}</label>
                          </div>
                          {/* TODO: Enable this value in next phase */}
                          {/* <div className="sensor-Name-machine limit-sensorName-sa">
                            <label>{latestJob.rated && latestJob.rated.time !== "" ? `${latestJob.rated.time} h` : `00:00 h`}</label>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="sensor-details-machine" title="Speed">
                        <div className="sensor-icon-machine status-orange"><FeatherIcon className={""} icon="compass" />
                      </div>
                      {/* TODO: Remove the mb-1 styling on next phase when enabling the below value */}
                      <div className="sensor-data-varna">
                        <div className="sensor-value limit-sensorValue-varna mb-1">
                           <label className='mb-0'>{latestJob.speed === "" || latestJob.speed == null ? `0 m/min`: `${Math.round(latestJob.speed)} m/min`}</label>
                        </div>
                        {/* TODO: Enable this value in next phase */}
                        {/* <div className="sensor-Name-machine limit-sensorName-sa">
                          <label>{latestJob.rated && latestJob.rated.speed !== "" ? `${latestJob.rated.speed} m/min` : `0 m/min`}</label>
                        </div> */}
                      </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="sensor-details-machine" title="Output">
                        <div className="sensor-icon-machine status-red"><FeatherIcon className={""} icon="award" />
                        </div>
                        <div className="sensor-data-varna">
                          {/* TODO: Remove the mb-1 styling on next phase when enabling the below value */}
                          <div className="sensor-value limit-sensorValue-varna mb-1">
                            <label className='mb-0'>{latestJob.output === "" || latestJob.output == null ? `0 m`: `${Math.round(latestJob.output)} m`}</label>
                          </div>
                          {/* TODO: Enable this value in next phase */}
                          {/* <div className="sensor-Name-machine limit-sensorName-sa ">
                            <label>{latestJob.rated && latestJob.rated.output !== "" ? `${latestJob.rated.output} m` : '0 m'}</label>
                          </div> */}
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="sensor-details-machine" title="Performance">
                        <div className="sensor-icon-machine status-green"><FeatherIcon className={""} icon="percent" />
                        </div>
                        <div className="sensor-data-varna">
                          {/* TODO: Remove the mb-1 styling on next phase when enabling the below value */}
                          <div className="sensor-value limit-sensorValue-varna mb-1">
                            <label className='mb-0'>{latestJob.performance === "" || latestJob.performance == null ? `0 %`: `${latestJob.performance} %`}</label>
                          </div>
                          {/* TODO: Enable this value in next phase */}
                          {/* <div className="sensor-Name-machine limit-sensorName-sa ">
                            {latestJob.rated && latestJob.rated.performance !== "" ? `${latestJob.rated.performance} %` : <label>0 %</label>}
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 pl-2 pr-2">
                  <div className="timeUpdateMachineList">
                    <label className="last-updated-Name">
                      Last Updated on {latestJob.lastUpdatedTime | latestJob.lastUpdatedTime === "" ? '2021-05-08 16:28:23' : latestJob.lastUpdatedTime}
                    </label>
                  </div>
                  <div className="row machine-status" >
                    <div className="text-center pl-3 ml-2">
                      <div className="card-content-heading machineStatus mb-2">Machine Status</div>
                      {latestJob.active ?
                        <div className="card-content-machineStatus text-green">ON</div> :
                        <div className="card-content-machineStatus text-red">OFF</div>
                      }
                    </div>
                    <div className="row m-r-10">
                      {jobEmployees.length > 0 &&
                        <div className="user-profile-machineList sa-cursor" onClick={() => props.onPressViewEmployees(props.machine.name, jobEmployees)}>
                          <div className="user-profile-inner" title={jobEmployees[0].employee.name}>
                            <img className="user-profile-image profile-center" src={Avatar} alt="profile" />
                          </div>
                        </div>
                      }
                      <div>
                        <label className="spy-machine-list-employee">{jobEmployees.length > 0 ? <label>+{jobEmployees.length - 1}</label> : 'No Employees'}</label>
                        {/* <label className="spy-machine-list-employee">+45 Others</label> */}
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div> :
          <div className="single-card-content-machine-item sa-cursor" onClick={goToReport}>
            <div className={"empty-results-center"}>
              <FeatherIcon icon="info" />
              <div className={"empty-results-text-machine-item"}>There is no active job</div>
            </div>
          </div>
        }
      </div>
    </div>
  )
};

export default MachineItem;
